import Grid from "@mui/material/Grid";
import Switch from "@mui/material/Switch";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { useTheme } from "@mui/material/styles";

export default function AutoReplySection({
  enabled,
  error,
  messages,
  onToggle,
  setMessages,
  createAutoReplyMessage,
  maxMessages = 2,
}) {
  const theme = useTheme();
  const autoReplies = messages.filter((m) => m.fromMe);

  const handleChangeMessage = (id, content) => {
    setMessages((prev) =>
      prev.map((m) => (m.id === id ? { ...m, content } : m)),
    );
  };

  const handleAddMessage = () => {
    if (autoReplies.length >= maxMessages) return;

    setMessages((prev) => [
      ...prev,
      createAutoReplyMessage(autoReplies.length),
    ]);
  };

  const handleRemoveMessage = (id) => {
    if (autoReplies.length <= 1) return;

    setMessages((prev) => prev.filter((m) => m.id !== id));
  };

  return (
    <>
      <Grid item xs={12} sx={{ display: "flex", alignItems: "center" }}>
        <Switch checked={enabled} onChange={onToggle} />
        <Typography sx={{ color: theme.palette.primary.main }}>
          Resposta automática
        </Typography>
      </Grid>

      <Grid item xs={12}>
        {enabled ? (
          <>
            {autoReplies.map((autoReply, index) => (
              <Box key={autoReply.id} sx={{ mb: 2 }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    mb: 0.75,
                  }}
                >
                  <Typography sx={{ fontSize: 13, fontWeight: 700 }}>
                    Mensagem {index + 1}
                  </Typography>
                  {autoReplies.length > 1 && (
                    <Button
                      size="small"
                      color="error"
                      onClick={() => handleRemoveMessage(autoReply.id)}
                      sx={{ textTransform: "none" }}
                    >
                      Remover
                    </Button>
                  )}
                </Box>

                <Box
                  component="textarea"
                  value={autoReply.content}
                  onChange={(e) =>
                    handleChangeMessage(autoReply.id, e.target.value)
                  }
                  placeholder="Digite a mensagem automática..."
                  sx={{
                    width: "100%",
                    minHeight: 180,
                    resize: "vertical",
                    p: 2,
                    borderRadius: "12px",
                    fontFamily: "monospace",
                    fontSize: 14,

                    border: "1px solid",
                    borderColor: error && !String(autoReply.content || "").trim()
                      ? theme.palette.error.main
                      : theme.palette.grey[300],

                    backgroundColor: theme.palette.background.paper,
                    color: theme.palette.text.primary,

                    outline: "none", // 🔑 remove focus ring nativo

                    "&:focus": {
                      borderColor: theme.palette.primary.main,
                      boxShadow: `0 0 0 2px ${theme.palette.primary.main}33`,
                    },

                    "&:hover": {
                      borderColor: theme.palette.grey[400],
                    },
                  }}
                />
              </Box>
            ))}

            {autoReplies.length < maxMessages && (
              <Button
                variant="outlined"
                onClick={handleAddMessage}
                sx={{ mb: 1.5, textTransform: "none" }}
              >
                Adicionar mensagem
              </Button>
            )}

            {error && (
              <Typography sx={{ color: "#d32f2f", fontSize: 12 }}>
                Todas as mensagens automáticas precisam ter texto.
              </Typography>
            )}
          </>
        ) : (
          <Box
            sx={{
              minHeight: "160px",
              border: "1px dashed #ccc",
              backgroundColor: "#F9F9F9",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Typography sx={{ color: theme.palette.primary.main }}>
              Ative a resposta automática para editar.
            </Typography>
          </Box>
        )}
      </Grid>
    </>
  );
}
